const getUser = () => {
    const user = localStorage.getItem('user');

    if (user) {
        return JSON.parse(user);
    }

    return null;
}

export const getUserId = () => {
    return getUser()?.id;
}

export const isAdmin = () => {
    const roles = getUser()?.roles;
    if (!roles || !Array.isArray(roles) || roles.length === 0) {
        return false;
    }
    return roles[0] !== 'ROLE_USER';
}


export const getRole = () => {
    return getUser()?.roles
}

export const channelRequired = () => (process.env.REACT_APP_CHANNEL_REQUIRED || '') == 'true';
export const audioPlayerVisible = () => (process.env.REACT_APP_AUDIO_PLAYER || '') == 'true';